import styled from 'styled-components';

export const End = ({
  isEarlyEnd,
  goMainEventTab,
}: {
  isEarlyEnd?: boolean;
  goMainEventTab: () => void;
}) => {
  return (
    <>
      <EndContainer>
        {isEarlyEnd && <EndTopText>많은 참여로 인한 참가 티켓 소진으로</EndTopText>}
        <EndText $earlyEnd={isEarlyEnd}>
          새틀라이트가 {isEarlyEnd ? '조기 ' : ' '} 종료되었습니다.
          <br />
          추후에 열릴 토너먼트도 많은 기대
          <br /> 부탁드립니다.
        </EndText>
        <EndSubText $isBottom={true}>
          참가 티켓을 획득하신분들은
          <br />
          <span>메인 이벤트 참가 안내 탭으로 이동</span>하여
          <br />
          토너먼트 정보를 확인해주세요!
        </EndSubText>
      </EndContainer>
      <BottomTabContainer onClick={goMainEventTab}>
        <GoTournamentBtn>메인 이벤트 참가 안내 확인하기</GoTournamentBtn>
      </BottomTabContainer>
    </>
  );
};

const EndSubText = styled.h4<{ $isBottom?: boolean }>`
  color: ${({ $isBottom }) =>
    $isBottom ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.4)'};
  text-align: center;
  font-weight: 400;
  letter-spacing: -0.92px;

  span {
    color: #fff1c9;
    border-bottom: 1px solid #fff1c9;
    font-weight: 500;
  }

  font-size: 18px;
  line-height: 26px;
`;

const EndTopText = styled.h4`
  font-weight: 500;
  letter-spacing: -0.02em;
  color: #ba8484;
  text-align: center;

  font-size: 16px;
  line-height: 38px;
  margin-bottom: 10px;
  margin-top: 30px;
`;

const EndText = styled.h3<{ $earlyEnd?: boolean }>`
  color: ${({ $earlyEnd }) => ($earlyEnd ? '#FF6062' : '#d3d3d3')};
  text-align: center;
  font-weight: 400;
  font-size: 64px;
  line-height: 70px;
  letter-spacing: -1.9px;
  margin-bottom: 30px;
  margin-top: ${({ $earlyEnd }) => ($earlyEnd ? '0' : '55px')};

  font-size: 26px;
  line-height: 34px;
  margin-bottom: 30px;
`;

const EndContainer = styled.div`
  flex: 1;
  padding-bottom: 100px;
  padding-left: 10px;
  padding-right: 10px;

  padding-top: 10px;
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
`;

const GoTournamentBtn = styled.button`
  left: 30%;
  height: 70px;
  width: 100%;
  cursor: pointer;
  box-shadow: 0px 1px 0px 0px rgba(255, 183, 183, 0.3) inset;
  background: linear-gradient(90deg, rgba(182, 0, 88, 0.85) 39.5%, rgba(174, 11, 114, 0.85) 100%);
  backdrop-filter: blur(25px);
  font-weight: 600;
  font-size: 21px;
  line-height: 28px;
  letter-spacing: -0.04em;
  color: #ffffff;
`;
